// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2r_8l","productName":"Table_productName__3Ksz6"};